import semver from 'semver';
/**
 * Compares two semantic versions. If you pass in a not valid semantic version, it will return
 * `null`. If you need some massage for the kiosk build version, see `extractSemver`
 * @param v1 - This parameter must be in strict semantic version format.
 * @param v2 - This parameter must be in strict semantic version format.
 * @returns isOlderVersion, isSameVersion, isGreaterVersion
 */
export function semverCompare(v1, v2) {
    if (!semver.valid(v1)) {
        return null;
    }
    if (!semver.valid(v2)) {
        return null;
    }
    return {
        isOlderVersion: semver.lt(v1, v2),
        isSameVersion: semver.eq(v1, v2),
        isGreaterVersion: semver.gt(v1, v2),
    };
}
/**
 * Extracts the semantic version from a build or release name, keeping any prerelease tag.
 * Accepts `biteinc-vitrine.1.35.59-glory.0`, `v1.82.2-dev.0`, `biteinc-garcon.0.22.0` and bare
 * `1.2.3`. Returns `null` when the name holds no valid semantic version.
 */
export function extractVersion(name) {
    const match = name.match(/\d+\.\d+\.\d+.*$/);
    return match ? semver.valid(match[0]) : null;
}
//# sourceMappingURL=versioning_helper.js.map